import { icon } from '@fortawesome/fontawesome-svg-core';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';

const sunIcon = icon(faSun).html[0];
const moonIcon = icon(faMoon).html[0];

/*import interfaces*/
import { Aeroval } from '../../types/global.js';
declare var aeroval: Aeroval;

import { getCookie, setCookie } from '../cookies/index.js';
import * as utils from '../../utils/index.js';

import './style.css'

type Theme = 'light' | 'dark'

export function initThemeToggle(divId: string) {

	//document.addEventListener('DOMContentLoaded', function () {
	const toggleThemeElement = document.getElementById(divId);
	if (!toggleThemeElement || toggleThemeElement.innerHTML) return;

	function updateThemeIcon(el: HTMLElement, iconHtml: string) {
		el.innerHTML = `<span class="theme-icon enter">${iconHtml}</span>`;
		requestAnimationFrame(() => {
			const span = el.querySelector('.theme-icon');
			if (span) {
				span.classList.add('active');
			}
		});
	}

	// set initial value
	let theme: Theme = getCookie('theme') as Theme ? getCookie('theme') as Theme : 'light';
	theme = utils.getQueryString('dark') == 'true' ? 'dark' : theme as Theme;

	if (theme === 'dark') {
		document.body.classList.add('dark-theme');
		updateThemeIcon(toggleThemeElement, sunIcon);
	} else {
		document.body.classList.remove('dark-theme');
		updateThemeIcon(toggleThemeElement, moonIcon);
	}
	toggleTheme(theme);

	// Add theme toggle logic
	toggleThemeElement.addEventListener('click', () => {
		document.body.classList.toggle('dark-theme');
		const newTheme = document.body.classList.contains('dark-theme') ? 'dark' : 'light';
		updateThemeIcon(toggleThemeElement, newTheme === 'dark' ? sunIcon : moonIcon);
		toggleTheme(newTheme);
		setCookie('theme', newTheme, 365);
	});
}

export function toggleTheme(value: Theme) {
	value == 'dark' ? enableDarkTheme() : disableDarkTheme();
	aeroval.settings.theme = value;
}

function enableDarkTheme(): void {
	// logos
	document.querySelectorAll('.full-logo').forEach((element) => {
		(element as HTMLImageElement).style.filter = 'invert(1)'
	});
	document.querySelectorAll('.simple-logo').forEach((element) => {
		(element as HTMLImageElement).style.filter = 'invert(1)'
	});

	// classes
	document.querySelectorAll('.bg-light').forEach((element) => {
		element.classList.remove('bg-light');
		element.classList.add('bg-dark');
	});

	document.querySelectorAll('.btn-light').forEach((element) => {
		element.classList.remove('btn-light');
		element.classList.add('btn-dark');
	});

	document.documentElement.setAttribute('data-bs-theme', 'dark');
}

function disableDarkTheme(): void {
	// logos
	document.querySelectorAll('.full-logo').forEach((element) => {
		(element as HTMLImageElement).style.filter = 'invert(0)'
	});
	document.querySelectorAll('.simple-logo').forEach((element) => {
		(element as HTMLImageElement).style.filter = 'invert(0)'
	});

	// classes
	document.querySelectorAll('.bg-dark').forEach((element) => {
		element.classList.remove('bg-dark');
		element.classList.add('bg-light');
	});

	document.querySelectorAll('.btn-dark').forEach((element) => {
		element.classList.remove('btn-dark');
		element.classList.add('btn-light');
	});
	document.documentElement.setAttribute('data-bs-theme', 'light');
}
